import { render, staticRenderFns } from "./PeriodoDistribucionAutocomplete.vue?vue&type=template&id=072540be"
import script from "./PeriodoDistribucionAutocomplete.vue?vue&type=script&lang=js"
export * from "./PeriodoDistribucionAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports